module.exports = __webpack_public_path__ + "static/media/kevin.3da8f91d.jpg";